<template>
  <div class="">
    <!-- header start -->
    <van-nav-bar 
      title="消息详情" 
      left-arrow 
      fixed 
      :z-index="99" 
      @click-left="onClickLeft" 
      :border="false"
    />
    <div class="navBarSpace"></div>
    <!-- header end -->

    <div class="msg-details">
      <div class="hd">
        <h2 class="title">{{newModel.Title}}</h2>
        <p class="date">{{newModel.AddDateTime}}</p>
      </div>
      <van-divider />
      <div class="bd">
        <!-- <p>姚贝娜，一个从青歌赛走姚贝娜街拍出来的女孩，-个对
        音乐的态度执着和自信的女孩，娴熟地穿行于经典与流行歌曲
        之间。</p>
        <p>四岁开始学习钢琴，从此姚贝娜在父母的精心培养下对音
        乐产生了浓厚的兴趣，九岁第一次登台演唱。童年时期参加多
        首歌曲的录制及现场演唱，多次在全国、省、市级的歌唱比赛
        中获奖。</p>
        <p>1997年9月，以优异的成绩考入武汉音乐学院附中，师从
        父亲姚峰副教授，开始系统地学习声乐，在校期间荣获第八届
        大红鹰杯全国青年歌手电视大奖赛湖北赛区专业组通俗唱法第
        二名，并进京参加决赛获得荧屏奖。</p>
        <p>1998年下半年，师从冯家慧教授学习民族声乐，并充分投
        入到学习与艺术实践中。</p>
        <p>2000年9月，考入中国音乐学院声歌系，先后师承董华副
        教授，马秋华教授，演唱水平有了较大提高。</p> -->
        <div v-html="newModel.Content"></div>
      </div>
    </div>
  </div>
</template>

<script>
	export default {
	  data() {
	    return {
        id: "",
        newModel : [],
	    };
	  },
	  components: {
    },
		methods :{
			onClickLeft() {
			  this.$router.go(-1)
      },
      getDetails(){
        var _this = this;
        this.$store
          .dispatch({
            type: "GetGenericArticleNewsDetail",
            id : _this.id,
          })
          .then(result => {
            console.log(result);
            _this.newModel = result.GenericArticleApiModel;
        });
      },
    },
    created(){
       var id = this.$route.query.id;
       this.id=id;
       this.getDetails();
    }
	};
</script>

<style scoped>
.msg-details{
  background-color: #fff;
  padding: 15px;
}
.msg-details>.hd{
 
}
.msg-details>.hd>.title{
  font-size: 15px;
  font-weight: normal;
  line-height: 1.5;
  text-align: center;
}
.msg-details>.hd>.date{
  font-size: 12px;
  color: #bbb;
  text-align: center;
  margin-top: 6px;
}
.msg-details>.bd{
  margin-top: 6px;
  font-size: 14px;
  color: #555;
}
</style>
